import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { SkillGlossary } from '@src/types/skill'
import * as R from 'ramda'

const useFetchSkillGlossaryJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<SkillGlossary>({
    fetchNow,
    path: ENV_CONFIG.JSON_URL.SKILL_GLOSSARY,
    deserialize: response =>
      R.pathOr({}, ['data', 'hints'], response) as SkillGlossary
  })
}

export default useFetchSkillGlossaryJson
